<div class="suspended-menu mat-elevation-z3" cdkDrag *ngIf="show" [ngStyle]="{'max-height':heigth + 'px'}">
    <div class="suspended-menu-actions" cdkDragHandle>
      <span>{{title}}</span>
      <span fxFlex id="aaa"></span>
      <div class="suspended-menu-actions-in">
        <mat-icon [@indicatorRotate]="expanded ? 'expanded': 'collapsed'" (click)="expanded=!expanded">
          expand_more
        </mat-icon>
      </div>
    </div>
    <div *ngIf="expanded" [@listAnimation] class="suspended-menu-list">
        <div class="suspended-menu-box" *ngFor="let item of data"  draggable="true" [attr.data-drag-data]="item" (dragstart)="drag($event)">{{item}}</div>
    </div>
</div>